import { render, staticRenderFns } from "./equipmentDrawing.vue?vue&type=template&id=2106735c"
import script from "./equipmentDrawing.vue?vue&type=script&lang=js"
export * from "./equipmentDrawing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2106735c')) {
      api.createRecord('2106735c', component.options)
    } else {
      api.reload('2106735c', component.options)
    }
    module.hot.accept("./equipmentDrawing.vue?vue&type=template&id=2106735c", function () {
      api.rerender('2106735c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/fim/equipmentDrawing.vue"
export default component.exports